// src/js/constants/action-types.js

export const SET_LANGUAGE = "SET_LANGUAGE";
export const STORE_LABELS = "STORE_LABELS";
export const STORE_MENU = "STORE_MENU";
export const STORE_LANGUAGES = "STORE_LANGUAGES";
